import { baseQuery } from "./baseQuery";
import { createApi } from "@reduxjs/toolkit/query/react";
import { v4 as uuidv4 } from "uuid";
export const smartRoutingService = createApi({
  reducerPath: "smartRoutingService",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getSmartRouting: builder.query<any, { merchantId: string }>({
      query: ({ merchantId }) => ({
        url: `/smart-routings/${merchantId}`,
        method: "GET",
        headers: {
          PageName: "Smart Routing",
        },
      }),
      transformResponse: (rawData: any) => {
        if (rawData.success) {
          return rawData;
        }
      },
    }),
    getSmartRoutingConfig: builder.query<any, { merchantId: string }>({
      query: ({ merchantId }) => ({
        url: `/smart-routings/${merchantId}/config`,
        method: "GET",
      }),
      transformResponse: (rawData: any) => {
        if (rawData.success) {
          return rawData.data;
        }
      },
    }),
    createSmartRouting: builder.mutation<any, any>({
      query: ({ id, ...others }) => ({
        url: `/smart-routings/${id}`,
        body: others,
        headers: {
          PageName: "Smart Routing",
        },
        method: "POST",
      }),
    }),
    updateSmartRouting: builder.mutation<any, any>({
      query: ({ id, merchantId, ...rest }) => ({
        url: `/payment-services/${merchantId}/${id}`,
        body: rest,
        method: "PUT",
      }),
    }),
    getSmartRoutingDetail: builder.query<any, any>({
      query: (params) => ({
        url: `/payment-services/${params.merchantId}/${params.id}`,
        params,
        method: "GET",
      }),
      transformResponse: (rawData: any) => {
        if (rawData.success) {
          return rawData.data;
        }
      },
    }),
    deleteSmartRouting: builder.mutation<any, any>({
      query: (params) => ({
        url: `/payment-services/${params.merchantId}/${params.id}`,
        params,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetSmartRoutingQuery,
  useLazyGetSmartRoutingQuery,
  useGetSmartRoutingConfigQuery,
  useGetSmartRoutingDetailQuery,
  useCreateSmartRoutingMutation,
  useUpdateSmartRoutingMutation,
  useDeleteSmartRoutingMutation,
} = smartRoutingService;
